import {
  ADD_SERVICELINE_FAILURE,
  ADD_SERVICELINE_LOADING,
  ADD_SERVICELINE_SUCCESS,
  FETCH_SERVICELINE_FAILURE,
  FETCH_SERVICELINE_LOADING,
  FETCH_SERVICELINE_SUCCESS,
  REMOVE_SERVICELINE_FAILURE,
  REMOVE_SERVICELINE_LOADING,
  REMOVE_SERVICELINE_SUCCESS,
  UPDATE_SERVICELINE_FAILURE,
  UPDATE_SERVICELINE_LOADING,
  UPDATE_SERVICELINE_SUCCESS
} from '../Types/servicelineTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const servicelineReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_SERVICELINE_LOADING:
    case ADD_SERVICELINE_LOADING:
    case UPDATE_SERVICELINE_LOADING:
    case REMOVE_SERVICELINE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };

    case FETCH_SERVICELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case ADD_SERVICELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Department added successfully',
        data: [...state.data, action.payload]
        // item: action.payload
      };

    case UPDATE_SERVICELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Department updated successfully',
        // item: action.payload
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item))
      };

    case REMOVE_SERVICELINE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Department removed successfully',
        data: state.data.filter(serviceLine => serviceLine._id !== action.payload)
      };

    case FETCH_SERVICELINE_FAILURE:
    case ADD_SERVICELINE_FAILURE:
    case UPDATE_SERVICELINE_FAILURE:
    case REMOVE_SERVICELINE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default servicelineReducer;
